<template>
    <div>
        <div class="space-y-4 text-sm">
            <div
                class="grid grid-cols-10 gap-2 lg:gap-4 space-y-4 lg:space-y-0"
            >
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlock
                        iconName="clock"
                        title="Next meeting"
                    >
                        <div v-if="bookingData.nextMeetingData">
                            <div>
                                {{
                                    bookingData.nextMeetingData.meeting
                                        .dateFormatted
                                }}
                            </div>
                            <div>
                                {{
                                    bookingData.nextMeetingData.meeting
                                        .startAtFormatted
                                }}
                                -
                                {{
                                    bookingData.nextMeetingData.meeting
                                        .endAtFormatted
                                }}
                            </div>
                            <div class="text-gray-600">
                                {{
                                    bookingData.nextMeetingData.meeting.duration
                                }}
                                mins
                            </div>
                            <div class="text-xs text-gray-600">
                                {{ displayTimezone }}
                            </div>
                        </div>
                        <div
                            v-else
                            class="text-gray-500"
                        >
                            -
                        </div>
                    </MeetingDetailsBlock>
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockMeetingLink
                        title="Next meeting's location"
                        :meeting="bookingData.nextMeetingData?.meeting"
                    />
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockService
                        :service="bookingData.service"
                    />
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockHost :host="bookingData.host" />
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockCustomer
                        :customer="bookingData.customer"
                    />
                </div>
            </div>

            <div v-if="bookingData.notes">
                <MeetingDetailsBlockNotes :notes="bookingData.notes" />
            </div>
        </div>

        <CardExpandSection :isCardExpanded="isCardExpanded" />
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import BookingData from '@/App/Booking/Booking/Entity/BookingData'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import CardExpandSection from '@/App/Booking/Meeting/Component/CardExpandSection.vue'
    import MeetingDetailsBlockMeetingLink from '@/App/Booking/Meeting/Component/MeetingDetailsBlockMeetingLink.vue'
    import MeetingDetailsBlockService from '@/App/Booking/Meeting/Component/MeetingDetailsBlockService.vue'
    import MeetingDetailsBlockHost from '@/App/Booking/Meeting/Component/MeetingDetailsBlockHost.vue'
    import MeetingDetailsBlockCustomer from '@/App/Booking/Meeting/Component/MeetingDetailsBlockCustomer.vue'
    import MeetingDetailsBlockNotes from '@/App/Booking/Meeting/Component/MeetingDetailsBlockNotes.vue'
    import type { TimeZoneEnum } from '@/Shared/AutoGenerated/TimeZoneEnum'

    const props = defineProps({
        bookingData: {
            type: Object as PropType<BookingData>,
            required: true,
        },
        isCardExpanded: {
            type: Boolean,
            required: true,
        },
        displayTimezone: {
            type: String as PropType<TimeZoneEnum>,
            required: true,
        },
    })
</script>
